module.exports = __webpack_public_path__ + "static/media/wallet_icon.be389642.svg";